import { useState } from 'react';

interface Props {
  mode: 'phase' | 'custom';
  color: string | null;
  onChange: (mode: 'phase' | 'custom', color: string | null) => void;
  canEdit: boolean;
}

const PRESETS = [
  { label: 'Red', value: '#EF4444' },
  { label: 'Orange', value: '#F97316' },
  { label: 'Yellow', value: '#F59E0B' },
  { label: 'Green', value: '#22C55E' },
  { label: 'Blue', value: '#3B82F6' },
  { label: 'Purple', value: '#9333EA' },
  { label: 'Gray', value: '#9CA3AF' },
];

export default function ScheduleItemModalColorSection({ mode, color, onChange, canEdit }: Props) {
  const [custom, setCustom] = useState(color || '#3B82F6');

  return (
    <div className="space-y-3">
      <p className="text-[#6B7280] text-xs">Choose how this item appears on the Gantt chart.</p>

      <div className="flex flex-wrap gap-2.5 items-start">
        {/* Phase color option */}
        <button
          type="button"
          onClick={() => canEdit && onChange('phase', null)}
          className={`flex items-center gap-2 px-3 py-2 rounded-xl border-2 cursor-pointer transition-colors min-h-[44px] ${
            mode === 'phase' ? 'border-[#E8621A] bg-[#FEF0E7]' : 'border-gray-100 hover:border-gray-200'
          }`}
        >
          <span className="w-5 h-5 rounded-full border border-gray-200 flex items-center justify-center">
            <i className="ri-palette-line text-[#9CA3AF] text-xs"></i>
          </span>
          <span className="text-xs font-medium text-[#1A1A1A]">Use phase color</span>
        </button>

        {/* Preset swatches */}
        {PRESETS.map((p) => (
          <button
            key={p.value}
            type="button"
            onClick={() => canEdit && onChange('custom', p.value)}
            className={`flex flex-col items-center gap-1 p-1.5 rounded-xl border-2 cursor-pointer transition-colors min-w-[52px] min-h-[52px] justify-center ${
              mode === 'custom' && color === p.value ? 'border-[#E8621A] bg-[#FEF0E7]' : 'border-gray-100 hover:border-gray-200'
            }`}
            title={p.label}
          >
            <span className="w-6 h-6 rounded-full block" style={{ backgroundColor: p.value }} />
            <span className="text-[9px] text-[#6B7280]">{p.label}</span>
          </button>
        ))}

        {/* Custom color */}
        <button
          type="button"
          onClick={() => canEdit && onChange('custom', custom)}
          className={`flex items-center gap-2 px-3 py-2 rounded-xl border-2 cursor-pointer transition-colors min-h-[44px] ${
            mode === 'custom' && !PRESETS.some((p) => p.value === color)
              ? 'border-[#E8621A] bg-[#FEF0E7]'
              : 'border-gray-100 hover:border-gray-200'
          }`}
        >
          <input
            type="color"
            value={custom}
            onChange={(e) => {
              if (!canEdit) return;
              setCustom(e.target.value);
              onChange('custom', e.target.value);
            }}
            className="w-6 h-6 p-0 border-0 rounded cursor-pointer"
            disabled={!canEdit}
          />
          <span className="text-xs font-medium text-[#1A1A1A]">Custom</span>
        </button>
      </div>
    </div>
  );
}
